export const generateInitials = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return '??';
  }

  const words = name.trim().split(/\s+/).filter(Boolean);
  
  if (words.length === 0) {
    return '??';
  }
  
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }
  
  // Take first letter of first word and first letter of last word
  const firstInitial = words[0].charAt(0).toUpperCase();
  const lastInitial = words[words.length - 1].charAt(0).toUpperCase();
  
  return firstInitial + lastInitial;
};
